import { defineMessages } from 'react-intl';

export const opinionSectionMessages = defineMessages({
  tooltip: {
    id: 'opinion_section.tooltip',
    defaultMessage:
      'Your feedback is essential to improve our application.\u000aClick on {likeIcon} if you find this feature useful,\u000aor {dontLikeIcon} if you think it is inappropriate. Thank you for your feedback!',
    description: 'Tooltip message for the opinion section',
  },
  likeIconTooltip: {
    id: 'opinion_section.like_icon_tooltip',
    defaultMessage: 'I find this feature useful/well designed',
    description: 'Like icon tooltip message for the opinion section',
  },
  dontLikeIconTooltip: {
    id: 'opinion_section.dont_like_icon_tooltip',
    defaultMessage: 'I find this feature unnecessary/poorly designed',
    description: 'Dont like icon tooltip message for the opinion section',
  },
  text: {
    id: 'opinion_section.text',
    defaultMessage: 'Your opinion <b>on this feature</b>',
    description: 'Text in the opinion section',
  },
  button: {
    id: 'opinion_section.button',
    defaultMessage: 'Submit',
    description: 'Submit button',
  },
  validationText: {
    id: 'opinion_section.validationText',
    defaultMessage: 'Thank you for your feedback! Your opinion has been taken into account.',
    description: 'validation message',
  },
});
